import { getOrderDetailsData, useAppSelector } from '@zonofi/zono-money-store';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

interface UseAdvancePaymentActionsProps {
  setSelectedTab?: React.Dispatch<React.SetStateAction<number>>;
  handleRemove: (
    values: Record<string, string>,
    includePaymentLink: boolean
  ) => void;
  removeLoading?: boolean;
}
export const useAdvancePaymentActions = ({
  setSelectedTab,
  handleRemove,
  removeLoading,
}: UseAdvancePaymentActionsProps) => {
  const [_, setSearchParams] = useSearchParams();
  const orderDetailsValue = useAppSelector(getOrderDetailsData);

  const handleModify = () => {
    setSelectedTab?.(1);
    setSearchParams(
      (prev) => {
        prev.set('tab', '1');
        prev.set('source', 'modify');
        return prev;
      },
      { replace: true }
    );
  };

  const manageAdvanceActions = useMemo(
    () => [
      { label: 'Modify', onPress: handleModify },
      {
        label: 'Remove',
        onPress: () => handleRemove(orderDetailsValue?.data, false),
        isLoading: removeLoading,
      },
    ],
    [handleRemove, handleModify, orderDetailsValue, removeLoading]
  );

  const settleAdvanceActions = useMemo(
    () => [
      { label: 'Mark as Paid', onPress: () => {} },
      { label: 'Modify', onPress: () => {} },
    ],
    []
  );

  return {
    manageAdvanceActions,
    // settleAdvanceActions,
  };
};
